import React from 'react';
import Alert from '@material-ui/lab/Alert';

export default (props) => {
  return (
		<Alert severity="error">
      An error has occurred
    </Alert>
  );
};


